import React from 'react';
import { View } from 'react-native';

import {
  renderGroup,
  ToggleButtonGroupChild,
  ToggleButtonGroupProps,
} from './toggle-button-group-render-utils';

function defInitialValue<T>(multiple: boolean, value?: T[]): T[] {
  if (Array.isArray(value)) {
    return value ? (multiple ? value : [value[0]]) : [];
  } else {
    return value ? [value] : [];
  }
}

export const ToggleButtonGroup = <T extends unknown>({
  children,
  style,
  multiple = false,
  value,
  onChange,
  onLayout,
}: ToggleButtonGroupProps<T>) => {
  const [selection, setSelection] = React.useState<T[]>(() =>
    defInitialValue<T>(multiple, value)
  );

  const handleOnChange = (value: T) => {
    let newSelection: T[];

    if (!multiple) {
      newSelection = selection[0] === value ? [] : [value];
    } else {
      newSelection = selection.includes(value)
        ? selection.filter((s) => s !== value)
        : [...selection, value];
    }

    setSelection(newSelection);
    onChange?.(newSelection);
  };

  const cloneToggleButton = (
    child: ToggleButtonGroupChild<T>
  ): ToggleButtonGroupChild<T> => {
    const onChange = (value: T) => {
      child.props.onChange?.(value);
      handleOnChange?.(value);
    };

    return {
      ...child,
      props: {
        ...child.props,
        selected: selection.includes(child.props.value),
        onChange,
      },
    };
  };

  return (
    <View style={style} onLayout={onLayout}>
      {renderGroup(children, cloneToggleButton)}
    </View>
  );
};

export default ToggleButtonGroup;
